// Only shorten the app's display copy; its shipping calculations remain unchanged.
const drawer = document.getElementById('cart-drawer');
if (drawer) {
  const updateShippingCopy = () => {
    for (const title of drawer.querySelectorAll('[class*="free_shipping_card_title_"]')) {
      const original = title.textContent.trim();
      let compact = original;
      const remaining = original.match(/^You're only (.+?) away from free shipping!$/i);
      if (remaining) compact = `${remaining[1]} away from FREE SHIPPING`;
      else if (/^Congratulations! You've got free shipping!$/i.test(original)) {
        compact = "You've unlocked FREE SHIPPING!";
      }
      if (compact !== original) title.textContent = compact;
    }
  };
  new MutationObserver(updateShippingCopy).observe(drawer, {
    childList: true, subtree: true, characterData: true,
  });
  updateShippingCopy();
}
